module.exports = __webpack_public_path__ + "static/media/user3.0393c8ba.png";